import { render, staticRenderFns } from "./TechnicalCards.vue?vue&type=template&id=640d7ffd&"
import script from "./TechnicalCards.vue?vue&type=script&lang=js&"
export * from "./TechnicalCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports